export default {
  headerContent: {
    title: 'Atlas Sigorta Ferdi Kaza Sigortası Fiyatları',
    slogan: "Ferdi Kaza Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'FERDİ KAZA SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Atlas Mutuel Sigorta Ferdi Kaza Sigortası',
    description: {
      title: 'Atlas Sigorta Ferdi Kaza Sigortası Nedir? ',
      content: [
        'Gündelik yaşamda beklenmedik kazalar, eğer maddi güvenceler yoksa oldukça kötü durumlara dönüşebilir. Bu durumların önüne geçmek için ferdi kaza sigortası yaptırmanız büyük önem taşır. Kaza sigortası kapsamında ani ve beklenmedik olaylara karşı pek çok konuda güvence alabilirsiniz.',
        '<strong>Atlas Sigorta ferdi kaza sigortası</strong>, sigortalı kişinin başına gelecek herhangi bir kaza durumunda sigortalı kişiye süreci atlatması ya da vefat halinde yakınlarının kullanması için tazminat ödemesi yapan sigorta türüdür. Sigorta kapsamında belirlenecek teminatlar ile çoğu kaza durumuna karşı güvence verilmektedir.'
      ]
    },
    subContent: {
      title: 'Atlas Sigorta Ferdi Kaza Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Sigorta kapsamında geniş bir kaza listesi yer almaktadır. Bu durumlarında sigortalı kişinin başına gelmesi halinde kendisine ya da yakınlarına ödeme yapılmaktadır. Ana teminatlar ve ek teminatlar kapsamında iki ana başlık altında güvenceler bulunmaktadır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Ferdi Kaza Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle:
    'Atlas Mutuel Sigorta Ferdi Kaza Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Atlas Sigorta Ferdi Kaza Sigortası Ana Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Yaşanma olasılığı yüksek olan durumlar temel alınarak hazırlanmış ana teminatlar şu şekildedir;',
          subList: [
            'Kaza sonucu maluliyet teminatı; sigortalının başına gelen kaza sonucunda kısmı ya da tam olarak malul olması durumunda sigortalıya tazminat ödemesi yapılır. Bu kapsamda belirlenmiş limit dâhilinde kişinin yaptığı meslek temel alınarak hesaplama gerçekleştirilir.',
            'Kaza sonucu vefat teminatı; sigortalı kişinin kaza sonucunda olay yerinde ya da belirtilen süreyi takiben vefat etmesi durumunda poliçede belirtilmiş yasal hak sahiplerine tazminat ödemesi yapılır.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ferdi Kaza Sigortası Ek Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Her ne kadar temel durumlar için ana teminatlar sunulmuş olsa da beklenmedik durumları göz önünde tutarak, oluşacak beklenmedik hasarlara karşı ek teminatlar ile daha geniş güvenceler sunulmaktadır. Ek teminatlar kapsamında;',
          subList: [
            '<strong>Tedavi masrafları;</strong> sigortalı kişinin poliçede belirlenmiş kazalardan birisini yaşaması durumunda oluşan tedavi masrafları, anlaşmalı hastanelerde olmak üzere karşılanır. Hastane masrafları sigorta poliçesinde belirtilmiş tutarlar üzerinden hesaplanmaktadır.',
            '<strong>İş görmezlik teminatı;</strong> sigortalı kişinin poliçede belirlenmiş kazalar sonucunda iş göremez hale gelmesi durumunda iş yapamadığı için oluşan maddi kaybı telafi edilir.',
            '<strong>Deprem teminatı;</strong> deprem sonucunda sigortalı kişinin gördüğü fiziksel zarar karşılanır ya da tazminat ödemesi yapılır.'
          ]
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Ferdi Kaza Sigortası Teminat Dışı Durumlar Nelerdir?',
      content: [
        {
          paragraph:
            'Teminat dışı kalan durumlar, sigorta poliçesinde detaylı olarak belirtilmiştir. Ferdi kaza sigortası kapsamında ödeme yapılması için sigortalının maruz kaldığı olayın kaza sayılan mahiyet taşıması gerekmektedir. Bu kapsamda aşağıda sıralanan haller kaza olarak görülmediğinden sigorta teminat dışı olarak tutulmuştur;',
          subList: [
            'Sel ya da diğer afetler; deprem teminatı yoksa deprem de dâhil olmak üzere doğal afetlerin yol açtığı hasarlar sigorta tarafından karşılanmaz.',
            'Grev, lokavt, halk hareketleri gibi eylemlerin sebep olduğu hasarlar,',
            'Terör eylemlerine sigortalı kişinin katılması sonucu oluşan hasarlar,',
            'Savaş ve savaşa bağlı olarak gerçekleşen hasarlar,',
            'İhtilal, isyan, ayaklanma gibi durumların sebep olduğu hasarlar,',
            'Nükleer rizikolar sonucu oluşmuş hasarlar,',
            'Sigortalı kişinin suça karışması ile oluşan hasarlar,',
            'Vahşi hayvan avcılığı sonucunda oluşan hasarlar,',
            'Kişinin kasıtlı olarak kendisine verdiği zararlar'
          ]
        },
        {
          paragraph:
            'Kaza olarak sayılmadığı için ilgili durumların gerçekleşmesi halinde sigorta ödeme yapmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Ferdi Kaza Sigortası Teminat Bedelleri Nasıl Belirlenir?',
      content: [
        {
          paragraph:
            'Teminat bedelleri belirlenirken, seçilen teminatın ve sigorta yaptıracak kişinin yaşı ile mesleği göz önünde tutulmaktadır. Bu şartlar altında teminat bedelleri kişiye özel hazırlanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ferdi Kaza Sigortası Güvenceleri Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası oluşabilecek her türlü kaza durumuna karşı güvence sağlamaktadır. Bu güvenceler arasında; beklenmedik kazalar, trafik kazaları, hayvan ısırmaları, zehirlenmeler, kırık – çıkık, her türlü sinir ve kas zedelenmesi durumlarına karşı güvenceler sunmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ferdi Kaza Sigortası Avantajları Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası ile kaza durumlarında oluşacak maddi zorluğu aşabilirsiniz. Bu sayede bu sürecin çabuk atlatılmasını sağlayabilir ya da vefat halinde mirasçılarınıza maddi kolaylıklar sunabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Ferdi Kaza Sigortası İçin Gerekli Bilgiler / Evraklar Nelerdir?',
      content: [
        {
          paragraph:
            '<strong>Atlas Sigorta ferdi kaza sigortası yaptırmak için</strong> kimlik bilgileri yeterli olmaktadır. Duruma göre sağlık belgesini içeren rapor da daha sonra eklenebilecektir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ferdi Kaza Sigortası Zorunlu Mudur?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası zorunlu bir sigorta değildir. Ancak yapılması halinde sunduğu avantajlar ile büyük yararlar sağlamaktadır. Özellikle beklenmedik durumlara karşı maddi güvenceniz olmasını sağlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ferdi Kaza Sigortası Şartları Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası, sağlık sigortası olmadığı için hastalık durumlarında herhangi bir ödeme yapmaz. Aynı zamanda ferdi kaza sigortası yaptıracakların prim ödemeleri genellikle yaşlarına ve meslek gruplarına göre belirlenmektedir. Tehlike barındıran mesleğe sahip olanların prim ödemeleri de daha yüksek olmaktadır. Ayrıca poliçe en az 1 yıllık süreyle düzenlenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ferdi Kaza Sigortasından Kimler Yararlanabilir?',
      content: [
        {
          paragraph:
            '18 – 60 yaş arasındaki herkes ferdi kaza sigortasından yararlanabilir. Bu yaşların dışındaki kişiler için özel şartlar hazırlanabilir ve bu sayede onlar da sigorta yaptırabilirler.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Ferdi Kaza Sigortasında Yararlanabileceğiniz Hizmetler Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası yanında sunulan temel asistans hizmetleri ile çoğu konuda yardım alabilir ve işlerinizi kolaylaştırabilirsiniz. Sunulan hizmetler;',
          subList: [
            'Tıbbi destek; kaza neticesinde oluşan durumlara acil müdahale için ilk yardım ekibi gönderilir. Yıllık belirlenen fiyatlar üzerinden değerlendirilir.',
            'Bilgi hizmetleri; 7 gün 24 saat erişim sağlanacak ilgili kanallardan sigortalı çeşitli konularda destek alabilir.',
            'Ulaştırma hizmeti; sigortalı veya yakınlarının kaza durumunda nakillerini gerektiren durumlarda ulaşım hizmeti sağlanır'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ferdi Kaza Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası yaptırmak için, gereken belgeler ile ilgili kanallardan başvuru yapmanız yeterlidir. Bu sayede kısa sürede işlemleriniz başlatılacak ve uygun şartları taşıyorsanız poliçeniz hazırlanacaktır. Teminatlar belirlendikten sonra hazırlanacak poliçe, hazırlandığı tarihten itibaren geçerlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ferdi Kaza Sigortasında Vergi İndirimi Var Mıdır?',
      content: [
        {
          paragraph:
            'Atlas Sigorta ferdi kaza sigortasında vergi indirimi imkânı bulunmaktadır. Sigortalı kişi çalıştığı yerin muhasebesine ya da ilgili birimine poliçe belgelerini göstermesi durumunda vergi indiriminden yararlanabilmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Ferdi Kaza Sigortasında Dikkat Edilmesi Gerekenler Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası yıllık süreler üzerinden belirlenir ve geçerli olduğu durumlarda sigortalı kişiye tazminat öder. Kaza olarak sayılmayan durumlarda geçerli olmadığı için kaza sayılmayan durumların sigortalı tarafından iyi bilinmesi önemlidir. Ayrıca ferdi kaza sigortası hastalık neticesinde oluşan masrafları da karşılamamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ferdi Kaza Sigortası Hesaplaması Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Sigorta hesaplaması seçilen teminatlara ve başvuru yapan kişinin özel şartlarına göre belirlenmektedir. Özellikle hesaplamada sigortalı olacak kişinin yaşı ve mesleği temel alınmaktadır. Prim ödemeleri belirli meslek gruplarına göre belirlenmiştir. ',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Ferdi Kaza Sigortası Prim Ödeme Koşulları Nelerdir?',
      content: [
        {
          paragraph:
            'Primleri Türk Lirası ya da Amerikan Doları üzerinden aylık, 3 aylık, 6 aylık ya da yıllık olarak ödemek mümkündür.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ferdi Kaza Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Fiyatlar, kişiye özel olmasından ötürü ancak fiyat teklifi sonucunda belirlenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ferdi Kaza Sigortası Fiyat Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph: 'Fiyat teklifini internet sitesi ve çağrı merkezi üzerinden alabilirsiniz. <strong>Atlas Sigorta ferdi kaza sigortası fiyat teklifi</strong> almak için internet sitemizden sigorta uzmanlarımıza bilgilerinizi iletebilirsiniz.',
          subList: null
        },
        {
          paragraph: 'Alokasko uzmanlarından fiyat teklifi almak isteyenler 7 gün 24 saat başvuru formunda bilgilerini uzmanlarımıza iletebilir.',
          subList: null
        },
        {
          paragraph: '<strong>Ferdi kaza sigortası fiyat teklifi için başvuru formunu doldurmanız yeterlidir.</strong>',
          subList: null
        }
      ]
    }
  ]
}
